// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ylJI","colMin":"styles_colMin__3iAvk"};